<template>
  <div class="container mt-4">
    <div class="row">
      <div class="col">
        <h2>Manage General Settings</h2>
      </div>
      <div class="col-auto">
        <my-button fa="" label="Create Setting" variant="box-general" classes="mr-1" height="48px" width="200px" @onClick="showCreateSettingModal"></my-button>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">
        <b-table :items="availableSettings" :fields="settingTableFields" striped responsive="sm">
          <template #cell(actions)="row">
            <my-button fa="pencil" label="" variant="box-general" classes="mr-1 mb-1" @onClick="showUpdateSettingModal(row.item)"></my-button>
            <!-- <my-button fa="trash" label="" variant="box-general" classes="mr-1 mb-1 text-danger" @onClick="showDeleteSettingMsg(row.item)"></my-button> -->
          </template>
        </b-table>
      </div>
    </div>

    <b-modal id="create-setting-modal" title="Create New Setting" hide-footer>
      <b-form ref="newSettingForm" @submit.stop.prevent="createNewSetting">
        <my-input id="setting-display-name" name="setting-display-name" label="Display Name" mandatory="true" placeholder="My Setting" inlinerows="false" ref="settingDisplayName" v-model="createModal.display_name" type="text"></my-input>
        <my-input id="setting-value" name="setting-value" label="Value" mandatory="true" placeholder="1" inlinerows="false" ref="settingValue" v-model="createModal.value" type="text"></my-input>

        <selector id="setting-type" name="setting-type" mandatory="true" label="Type" :data="settingTypes" valuefield="type_id" textfield="type_name" inlinerows="false" classes="bg-gray" blockClasses="" blockLabelClass="col-md-12 pl-0 pr-0" ref="settingType" v-model="createModal.type"></selector>

        <my-button label="Create Setting" variant="solid-primary" classes="mt-4" height="56px" width="100%" type="submit"></my-button>
      </b-form>
    </b-modal>

    <b-modal id="update-setting-modal" title="Update Setting" hide-footer>
      <b-form ref="updateSettingForm" @submit.stop.prevent="updateSetting">
        <my-input id="setting-display-name" name="setting-display-name" label="Display Name" mandatory="true" placeholder="My Setting" inlinerows="false" :defaultText="updateModal.display_name" v-model="updateModal.display_name" type="text"></my-input>
        <my-input id="setting-value" name="setting-value" label="Value" mandatory="true" placeholder="1" inlinerows="false" :defaultText="updateModal.value" v-model="updateModal.value" type="text"></my-input>

        <selector id="setting-type" name="setting-type" mandatory="true" label="Type" :data="settingTypes" valuefield="type_id" textfield="type_name" inlinerows="false" classes="bg-gray" blockClasses="" blockLabelClass="col-md-12 pl-0 pr-0" :selected="updateModal.type" v-model="updateModal.type"></selector>

        <my-button label="Update Setting" variant="solid-primary" classes="mt-4" height="56px" width="100%" type="submit"></my-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
/**
 * Sparkfore Admin - Settings Page
 */
import MyButton from "../../components/atoms/Button.vue";
import MyInput from "../../components/atoms/Input.vue";
import Selector from "../../components/atoms/Selector.vue";

export default {
  name: "admin-manage-settings",

  async beforeCreate() {
    await this.$store.dispatch("getGeneralSettings");
  },
  computed: {
    availableSettings() {
      return this.$store.getters.generalSettings;
    },
  },

  data: function() {
    return {
      settingTypes: [
        { type_id: "text", type_name: "Text" },
        { type_id: "number", type_name: "Number" },
      ],

      createModal: {
        display_name: "",
        value: "",
        type: "",
      },

      updateModal: {
        id: "",
        display_name: "",
        value: "",
        type: "",
      },

      deleteModal: {
        id: "",
      },
      settingTableFields: ["display_name", "type", "value", "actions"],
      // availableSettings:[
      //     {'id': 1, 'display_name': "LMS Name", "type": "Text", "value": "Nice LMS"}
      // ]
    };
  },

  methods: {
    showCreateSettingModal() {
      this.$bvModal.show("create-setting-modal");
    },

    showUpdateSettingModal(item) {
      this.updateModal.id = item.id;
      this.updateModal.display_name = item.display_name;
      this.updateModal.value = item.value;
      this.updateModal.type = item.type;
      this.$bvModal.show("update-setting-modal");
    },

    showDeleteSettingMsg(item) {
      this.$fire({
        title: "Warning",
        text: "Are you sure you want to delete this item?",
        type: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((r) => {
        if (r.value && r.value == true) {
          this.deleteModal.id = item.id;
          // console.log("delete initiated");
          this.deleteSetting();
        }
      });
    },

    createNewSetting() {
      this.$bvModal.hide("create-setting-modal");

      this.$store.dispatch("createGeneralSetting", JSON.stringify(this.createModal)).then((result) => {
        if (result.success == true) {
          this.$fire({
            title: result.message,
            // text: "text",
            type: "success",
            timer: 3000,
          }).then(() => {
            this.resetFields();
          });
        } else {
          this.$fire({
            title: result.message,
            // text: "text",
            type: "error",
            html: "",
          });
        }
      });
    },

    updateSetting() {
      this.$bvModal.hide("update-setting-modal");

      this.$store.dispatch("updateGeneralSetting", JSON.stringify(this.updateModal)).then((result) => {
        if (result.success == true) {
          this.$fire({
            title: result.message,
            // text: "text",
            type: "success",
            timer: 3000,
          }).then(() => {
            this.resetFields();
          });
        } else {
          this.$fire({
            title: result.message,
            // text: "text",
            type: "error",
            html: "",
          });
        }
      });
    },

    deleteSetting() {
      this.$store.dispatch("deleteGeneralSetting", JSON.stringify(this.deleteModal)).then((result) => {
        if (result.success == true) {
          this.$fire({
            title: result.message,
            // text: "text",
            type: "success",
            timer: 3000,
          }).then(() => {});
        } else {
          this.$fire({
            title: result.message,
            // text: "text",
            type: "error",
            html: "",
          });
        }
      });
    },

    resetFields() {
      this.createModal = {
        display_name: "",
        value: "",
        type: "",
      };

      this.updateModal = {
        display_name: "",
        value: "",
        type: "",
      };
    },
  },

  components: {
    MyButton,
    MyInput,
    Selector,
  },
};
</script>
